import React, { useMemo } from 'react';
import { SubTotalAmount } from './SubTotal';
import { convertValueToUSD } from '../../../../../../helpers/currency.helper';
import { TotalAmount } from './TotalAmount';
import { Discount, DISCOUNT_TYPES } from './Discount';
import { TaxRate } from './TaxRate';
import { useStore } from '../../../../../../store';
import { IProduct } from '../../../types/types';

interface IProps{
  products: IProduct[]
}
export const SummaryData = ({ products } : IProps) => {
  const invoiceData = useStore(state => state.invoiceData);
  const formatAmount = (amount: number) => convertValueToUSD(amount, 2);
  const isServiceItems = useMemo(() => products.length > 0, [products]);
  const calculateTotalPriceBeforeDiscount = () => products.reduce((sum, product) => sum + product.amount * product.quantity, 0);
  const discountValue = useMemo(() => {
    const subtotalAmount = calculateTotalPriceBeforeDiscount();
    const discount = invoiceData.invoiceService?.discount;
    const discountType = invoiceData.invoiceService?.discountType;

    if (!calculateTotalPriceBeforeDiscount() || !discountType || !discount) return 0;
    if (discountType === DISCOUNT_TYPES.PERCENT) {
      return discount * subtotalAmount;
    } if (discountType === DISCOUNT_TYPES.FIXED) {
      return discount;
    }
    return 0;
  }, [products, invoiceData]);

  const taxValue = useMemo(() => {
    const subtotalAmount = calculateTotalPriceBeforeDiscount();
    const salesTax = invoiceData.invoiceService?.salesTax;

    if (!subtotalAmount || !salesTax) return 0;
    return salesTax * (subtotalAmount - discountValue);
  }, [invoiceData, products]);

  const totalValue = useMemo(() => {
    const subtotalAmount = calculateTotalPriceBeforeDiscount();
    if (!subtotalAmount) return 0;
    return subtotalAmount - discountValue + taxValue;
  }, [taxValue, discountValue, products, invoiceData]);
  return (
    <div className='flex flex-col w-[340px] shadow-light border border-bw03 rounded-[8px]'>
      <SubTotalAmount value={formatAmount(calculateTotalPriceBeforeDiscount() || 0)} title='Subtotal' />
      {isServiceItems && <Discount subtotalAmount={calculateTotalPriceBeforeDiscount()} totalAmount={totalValue} discountType={invoiceData?.invoiceService?.discountType} discountAmount={invoiceData?.invoiceService?.discount} />}
      {isServiceItems && <TaxRate amount={calculateTotalPriceBeforeDiscount()} salesTax={invoiceData?.invoiceService?.salesTax} discountType={invoiceData?.invoiceService?.discountType} discountAmount={invoiceData?.invoiceService?.discount} />}
      <TotalAmount totalAmount={Math.max(totalValue, 0)} subtotalAmount={calculateTotalPriceBeforeDiscount()} title='Total' />
    </div>
  );
};
